import { ExclusionOrderModel } from '../../models/exclusionOrderModel';

type TranslateFn = (key: string) => string;

export type FieldItem = {
  label: string;
  value: string | number;
};

export const getGeneralInfoFields = (
  t: TranslateFn,
  order: ExclusionOrderModel,
): FieldItem[] => [
  { label: t('exclusionOrder.reportNo'), value: order.reportNo },
  {
    label: t('exclusionOrder.exclusionType'),
    value: t(order.exclusionTypeKey),
  },
  { label: t('exclusionOrder.venue'), value: order.venueName },
  { label: t('exclusionOrder.requestedOn'), value: order.createdAtFormatted },
];

export const getPoiDetailsFields = (
  t: TranslateFn,
  order: ExclusionOrderModel,
): FieldItem[] => [
  { label: t('exclusionOrder.poiNo'), value: '-' },
  { label: t('exclusionOrder.gender'), value: '-' },
  { label: t('exclusionOrder.name'), value: order.playerFullName },
  { label: t('exclusionOrder.dateOfBirth'), value: order.playerDob || '-' },
  { label: t('exclusionOrder.description'), value: '-' },
  { label: t('exclusionOrder.age'), value: '-' },
  { label: t('exclusionOrder.address'), value: order.playerAddress || '-' },
  { label: t('exclusionOrder.ethnicity'), value: '-' },
];

export const getExclusionPeriodFields = (
  t: TranslateFn,
  order: ExclusionOrderModel,
): FieldItem[] => [
  { label: t('exclusionOrder.from'), value: order.startDateFormatted },
  {
    label: t('exclusionOrder.expiresIn'),
    value: order.isActive
      ? `${order.expiresInDisplay} ${t('exclusionOrder.days')}`
      : t(order.expiresInDisplay),
  },
  { label: t('exclusionOrder.until'), value: order.durationLabel },
  { label: t('exclusionOrder.breaches'), value: order.breachCount },
];
